import { Outlet, useLocation } from 'react-router-dom';
import { Box } from '@mui/material';
import Header from './Header';
import Footer from './Footer';
import { WhatsAppButton } from '../components/ui';

// Pages that should have transparent header over hero section
// Home page now has white background, so no transparent header needed
const transparentHeaderPages = [];

export default function MainLayout() {
  const location = useLocation();
  const isTransparentHeader = transparentHeaderPages.includes(location.pathname);

  return (
    <Box
      sx={{
        display: 'flex',
        flexDirection: 'column',
        minHeight: '100vh',
      }}
    >
      <Header transparent={isTransparentHeader} />

      <Box component="main" sx={{ flexGrow: 1 }}>
        <Outlet />
      </Box>

      <Footer />
      <WhatsAppButton />
    </Box>
  );
}
